/**
 * Created by hp on 2017/5/25.
 */
import React from 'react';
import axios from 'axios';
import ErrorMessage from './ErrorMessage'

import '../../styles/common.css';
import '../../styles/messages/RedpackMessage.css';

import redpackPng from '../../images/redpack2.png';

export default class RedpackMessage extends React.PureComponent {
    constructor() {
        super();
        this.onRepackClick = this.onRepackClick.bind(this);
    }

    render() {
        try {
            let {message} = this.props;

            return (
                <div className="redpack" onClick={this.onRepackClick}>
                    <div className="weui-flex">
                        <div className="weui-flex__item flex_1">
                            <img src={redpackPng} alt=""/>
                        </div>
                        <div className="weui-flex__item flex_3 redpack-text overflow-hidden">
                            <p className="description">{message.content}</p>
                            <p className="getit">领取红包</p>
                        </div>
                    </div>
                    <p className="redpack-inert-notice">荔枝微课红包</p>
                </div>
            )
        } catch(e) {
            return <ErrorMessage/>
        }
    }

    onRepackClick() {
        let {message, lecture} = this.props;
        let url = `/api/classroom/${lecture.id}/redpack/${message.meta.redpack_id}/grab`;
        axios.post(url).then((res) => {
            if (res.data.code === 2) {
                return this.context.page.showAlert(res.data.msg);
            }

            let data = res.data.data;
            let redpackGrab = {
                code: res.data.code,
                msg: res.data.msg,
                fee: data.fee / 100,
                sender_nickname: data.redpack.sender_nickname,
                description: data.redpack.description,
                sender_headimgurl: data.redpack.sender_headimgurl,
                total_count: data.redpack.total_count,
                total_fee: data.redpack.total_fee,
                available_count: data.redpack.available_count,
                available_fee: data.redpack.available_count
            };
            this.props.dispatch({
                type: 'SET_REDPACK_MESSAGE',
                preload: message,
            });
            this.props.dispatch({
                type: 'SET_REDPACK_GRAB',
                preload: redpackGrab,
            });
            this.props.dispatch({
                type: 'SHOW_REDPACK_GRAB_DIALOG'
            });
        });
    }
}

RedpackMessage.contextTypes = {
    page: React.PropTypes.object,
    messageList: React.PropTypes.object,
};



// WEBPACK FOOTER //
// ./src/components/messages/RedpackMessage.js